// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Get_TaskDependenciesType } from '../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupGetTaskDependenciesType = () => {
  const dispatch = useDispatch();

  const { i18n, t } = useTranslation();

  useEffect(() => {
    if (TaskDependenciesType?.length === 0) {
      dispatch(Get_TaskDependenciesType());
    }
  }, []);

  const { TaskDependenciesType, loading, error } = useSelector(state => state.Lookup);

  const OptionsTaskDependenciesType =
    TaskDependenciesType &&
    TaskDependenciesType?.map((item, idx) =>
      item.list?.map(list => ({
        value: list.lookupCode,
        label: i18n.language === 'en' ? list.meaning : list.meaning2
      }))
    ).flat();

  return { TaskDependenciesType, OptionsTaskDependenciesType, loading, error };
};

export default useLookupGetTaskDependenciesType;
